import { render, staticRenderFns } from "./EditUserView.vue?vue&type=template&id=373fc3b2"
import script from "./EditUserView.vue?vue&type=script&lang=js"
export * from "./EditUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports